exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-special-banners[data-v-465c2a38]{width:350px;margin-bottom:10px;border-radius:4px}@media screen and (max-width:700px){.img-special-banners[data-v-465c2a38]{width:100%;padding:0 .6em 0 .5em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-465c2a38","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/banners/RightSpecialBanners.vue
// module id = hmwI
// module chunks = 0